module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Justice as a Virtue")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('p', {
    staticClass: "Toc1a"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#prf-001",
      "id": "prf001"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgment#ack-001",
      "id": "ack001"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001",
      "id": "ch001"
    }
  }, [_c('b', [_vm._v("1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Justice as a Virtue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch-001s1",
      "id": "ch001s1"
    }
  }, [_vm._v("Preliminary Considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch-001s2",
      "id": "ch001s2"
    }
  }, [_vm._v("The Theoretical Framework")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch-001s3",
      "id": "ch001s3"
    }
  }, [_vm._v("The Virtues as Normative Ideals")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch-001s4",
      "id": "ch001s4"
    }
  }, [_vm._v("An Overview of the Virtue of Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch-001s5",
      "id": "ch001s5"
    }
  }, [_vm._v("Reason, Revelation, and Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002",
      "id": "ch002",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Virtues and Vices of the Will")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch-002s1",
      "id": "ch002s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Will as a Causal Principle")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch-002s2",
      "id": "ch002s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Will as the Principle of Voluntary Actions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch-002s3",
      "id": "ch002s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Habits of the Will")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch-002s4",
      "id": "ch002s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice as a Perfection of the Will")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "id": "ch003",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Justice as a Moral Ideal")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch-003s1",
      "id": "ch003s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice, Equality, and Right")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch-003s2",
      "id": "ch003s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Equality, Right, and Obligation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch-003s3",
      "id": "ch003s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice, Practical Reason, and First Principles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch-003s4",
      "id": "ch003s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Common Good, Political Rule, and the Ideal of Equality")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "id": "ch004",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("From Ideal to Law")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch-004s1",
      "id": "ch004s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norm, Precept, and Act")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch-004s2",
      "id": "ch004s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice and the Moral Emotions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch-004s3",
      "id": "ch004s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Norms of Nonmaleficence")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch-004s4",
      "id": "ch004s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Place of Discernment in the Activities of Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "id": "ch005",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Perfections of the Will")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch-005s1",
      "id": "ch005s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reason and the Virtues")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch-005s2",
      "id": "ch005s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Value, Morality, and Perfections of the Will")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch-005s3",
      "id": "ch005s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commitment and Regard, Two Aspects of Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch-005s4",
      "id": "ch005s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib-001",
      "id": "bib001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx-001",
      "id": "idx001",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Name Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx-002",
      "id": "idx002",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Subject Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0